/* eslint-disable react/require-default-props */
import React from 'react';
import { inject } from 'mobx-react';
import Link from 'core/components/Link';
import { IReactComponent } from 'mobx-react/dist/types/IReactComponent';

type DeviceLinkProps = {
  // TODO: improve typing for $app
  $app: {
    isSubtenant: boolean;
  };
  name: string;
  snmp_id?: string | number;
  children?: React.ReactNode;
};

// Component to create a link to a device or its interface based on the provided props
// Avoid rendering device link to interfaces/tenant if the user is MKP
const DeviceLink = ({ $app, name, children, snmp_id, ...rest }: DeviceLinkProps) => {
  if ($app.isSubtenant) {
    return children || name;
  }
  let path = `/v4/infrastructure/devices/${name}`;
  if (snmp_id) {
    path += `/interfaces/${snmp_id}`;
  }
  return (
    <Link to={path} {...rest}>
      {children || name}
    </Link>
  );
};

export default inject('$app')(DeviceLink as unknown as IReactComponent);
